import { BACKEND_URI } from "../entries";
import { devLog } from "../utils/loggerUtils";
import { secureAPICall } from "../utils/sessionUtils";



export const requestPermissionsList = async ({verbose=false}) => {
    return secureAPICall({endpoint: BACKEND_URI + "/api/permissions/get-permissions", verbose:verbose})
}


export const requestGuestPermissionsList = async ({verbose=false}) => {

    const response = await fetch(BACKEND_URI + "/api/permissions/get-guest-permissions", {
        method: "POST",
        mode: "cors",
        credentials: "include"
    })
    const result = await response.json()

    if (!response.ok) {
        throw {
            status: response.status,
            message: result.message
        }
    }

    if (verbose) {
        devLog(response.status, result.message)
        devLog(result)
    }

    return result.data
    
}


export const requestAllPermissionsList = async ({verbose=false}) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/permissions/get-all-permissions", verbose: verbose})
}


export const requestUserPermissionList = async ({user_id, verbose=false}) => {
    const formData = new FormData()
    formData.append("user_id", user_id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/permissions/get-user-permissions", body: formData, verbose: verbose})
}


export const requestRankPermissionList = async ({rank, verbose=false}) => {
    const formData = new FormData()
    formData.append("rank", rank)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/permissions/get-rank-permissions", body: formData, verbose: verbose})
}


export const requestChangeUserPermissions = async ({userId, rank, addList, removeList, verbose=false}) => {
    const formData = new FormData()
    formData.append("user_id", userId)
    formData.append("rank", rank)
    addList.forEach((element) => {
        formData.append("add_list", element)
    })
    if (addList.length === 0) {
        formData.append("add_list", [])
    }
    removeList.forEach((element) => {
        formData.append("remove_list", element)
    })
    if (removeList.length === 0) {
        formData.append("remove_list", [])
    }
    return secureAPICall({ endpoint: BACKEND_URI + "/api/permissions/change-user-permissions", body: formData, verbose: verbose})
}